module.exports = __webpack_public_path__ + "img/partner_sell.12384747.png";